<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Documents
            <v-icon class="error--text ml-2" size="30" style="color:#ffffff  !important" @click="logout()" >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
     <v-card tile style="background:none" flat>
      <v-card-text class="pa-0 mx-auto">
            <v-data-table
              :headers="headers"
              item-key="project_id"
              class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
              :search="search"
              :items="items.data"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :items-per-page="pagination.itemsPerPage"
              hide-default-footer
              :options.sync="pagination"
              :page.sync="pagination.page"  
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="3%">
                    <v-icon @click="editRecord(item.domain_id)">
                      mdi-clipboard-edit-outline
                    </v-icon>
                  </td>
                  <td width="7%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="86%">
                    {{item.domain}}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="v-data-footer custom-pagination fix-footer-bar">
              <v-row dense="">
                <v-col cols="4" class="d-flex align-center justify-end">
                  <span>Total Record: {{items.total}}</span>
                  <div class="v-data-footer__select pl-5">Rows per page: 
                    <v-select
                      v-model="pagination.itemsPerPage"
                      :items="pagination_settings.perPageList"
                      dense=""
                      hide-details=""
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="8" class="d-flex align-center justify-start">
                  <v-pagination
                  class="d-flex align-center justify-start"
                    v-model="pagination.page"
                    :length="items.last_page"
                    total-visible="22"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          <!-- </v-col>
        </v-row> -->
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets, logout } from "../../plugins/helper";
import { mapState,mapMutations } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      form_data: {},
      form_error: {},
      edit_form_data: {},
      edit_form_error: {},
      search: "",
      form_loading:false,
      domain_id: null,
      loading: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "", sortable: false, class:'', width: '3%' },
        { value: "checkbox", text: "#", sortable: false, width:"7%"},
        { value: "domain", text: "Name", sortable: false, width:"86%" },
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["domain"],
        page: 1,
        filters: {
          item_active: true,
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu : false
    };
  },
  components: {
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "domain";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val
    },
    search() {
      this.getEmailDomains();
    },
    pagination: {
      handler: function () {
        this.getEmailDomains();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    editRecord(domain_id) {
      this.domain_id = domain_id;
      this.edit_dialog=true;
      this.getEmailDomainDetails(domain_id)
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getEmailDomains() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("domain_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
           _self.setData({key : 'alphabets',value : response.data.alphabets})
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addEmailDomain() {
      let _self = this;
      // this.loading = "accent";
      _self.form_loading = true;
      axios.post("add_domain", _self.form_data)
        .then((response) => {
          _self.form_data = {};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false
            _self.getEmailDomains()
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    updateEmailDomain(){
      let _self = this;
      _self.edit_form_data.domain_id = _self.domain_id
      axios.post("update_domain", _self.edit_form_data)
        .then((response) => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {}
            _self.form_loading = false;
            _self.edit_dialog = false
            _self.getEmailDomains();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    getEmailDomainDetails(domain_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_domain_details?domain_id="+domain_id)
        .then((response) => {
          _self.edit_form_data.domain = response.data.data.domain;
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteJobs(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.domain_id)
      })
      axios.post("delete_domain",{
        ids : ids
      }).then(function(response){
        _self.setAlert({
          show: true,
          variant: response.data.variant,
          message: response.data.message,
          dismissCountDown: 0
        });
        _self.getEmailDomains()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    this.getEmailDomains();
  },
};
</script>